import { DEFAULT_GHOST } from '../AppearanceDefinitions';
import type { HumanoidAppearance } from '../GhostRenderer';
import { withNpcEyes } from '../npcEyes';

/** Base a config on DEFAULT_GHOST; every hand-authored NPC portrait is
 *  unarmed and their clothing is drawn by the humanoid garment layer, not
 *  GearParts (see CoilNpcAppearances.ts for why). Held props such as a
 *  warden's spear are `humanoid.props`, never `weapon`. */
export function npc(over: Partial<HumanoidAppearance>): HumanoidAppearance {
  return withNpcEyes({ ...DEFAULT_GHOST, weapon: undefined, equipment: undefined, ...over });
}
